import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSidebarTab } from 'redux/modules/job-detail/duck';

import { getJobDetailData, getSidebarTab } from 'redux/modules/job-detail/selectors';

import { Logs } from 'modules/log';
import History from 'modules/Common/History';
import AssignedDriverMap from 'modules/journey/mapAssignedDriver';
import Conversation from 'modules/chat/Conversation';

import { SidebarStyled, SidebarTabStyled as TabTitleStyled } from 'modules/detail/styled';
import { Flexer } from '@ontruck/orc';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const tabs = {
  LOGS: {
    tabName: 'LOGS',
    component: (journey) => {
      const shipperOrdersSkin = (journey || {}).shipper_orders_skin;
      const shipperOrders = Object.keys(shipperOrdersSkin || {});

      return (
        <>
          <Logs
            journeyId={(journey || {}).id}
            showAddLog={!!shipperOrders.length}
            shipperOrdersSkin={shipperOrdersSkin}
            shipperOrderId={shipperOrders.length === 1 ? shipperOrders[0] : undefined}
            flex="3"
          />
          <History flex="1" journey={journey} />
        </>
      );
    },
  },
  CHAT: {
    tabName: 'CHAT',
    component: (journey) => (
      <Conversation
        journeyId={journey && journey.id}
        conversationId={journey && journey.conversation_id}
        driverName={journey && journey.driver && journey.driver.contact_name}
      />
    ),
  },
  MAP: {
    tabName: 'MAP',
    component: () => <AssignedDriverMap />,
  },
};

const JourneySidebar = ({ tabsToDisplay }) => {
  const selectedTab = useSelector(getSidebarTab);
  const journey = useSelector(getJobDetailData);
  const availableTabs = Object.keys(tabs).filter((tab) => tabsToDisplay.includes(tab));
  const onlyOneTab = availableTabs.length === 1;
  const dispatch = useDispatch();

  const isZendeskEnabled = useSelector((store) =>
    getSpecificClientConfig(store, constants.ZENDESK)
  );

  const handleSelectTab = useCallback(
    (tab) => {
      dispatch(setSidebarTab(tab));
    },
    [dispatch]
  );

  return (
    <SidebarStyled>
      <Flexer.Parent>
        {availableTabs.map((tab) => (
          <>
            {!(!isZendeskEnabled && tab === 'CHAT') && (
              <TabTitleStyled
                onClick={() => handleSelectTab(tab)}
                active={tab === selectedTab && !onlyOneTab}
              >
                {tabs[tab].tabName}
              </TabTitleStyled>
            )}
          </>
        ))}
      </Flexer.Parent>
      {tabs[selectedTab] && tabs[selectedTab].component(journey)}
    </SidebarStyled>
  );
};

export default JourneySidebar;
